/**
 * Returns a tel: URL for use in href attributes.
 * Normalizes display number to digits; adds +1 for 10-digit US numbers.
 */
export const formatTelHref = (displayNumber) => {
  if (!displayNumber || typeof displayNumber !== 'string') {
    return '';
  }
  const digits = displayNumber.replace(/\D/g, '');
  if (digits.length === 0) {
    return '';
  }
  if (digits.length === 10) {
    return `tel:+1${digits}`;
  }
  return `tel:${digits}`;
};
